import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { apiPost } from "../lib/api";
import { AuthLayout } from "../components/AuthLayout";
import { Alert, Spinner } from "../components/ui";

/* Landing page for the unsubscribe link in an alert email. Public — someone
   clicking from their mail app is very likely not signed in, and making them
   sign in just to stop email would be hostile. */
export function UnsubscribePage() {
  const [params] = useSearchParams();
  const [state, setState] = useState("working"); // working | done | failed
  const [error, setError] = useState("");

  const id = params.get("id") || "";
  const token = params.get("token") || "";

  useEffect(() => {
    let cancelled = false;
    async function run() {
      if (!id || !token) {
        if (!cancelled) {
          setError("This unsubscribe link is incomplete.");
          setState("failed");
        }
        return;
      }
      try {
        await apiPost("/alerts-unsubscribe", { id, token });
        if (!cancelled) setState("done");
      } catch (e) {
        if (!cancelled) {
          setError(e.message || "That unsubscribe link is invalid or has expired.");
          setState("failed");
        }
      }
    }
    run();
    return () => {
      cancelled = true;
    };
  }, [id, token]);

  return (
    <AuthLayout title="Gear Exchange alerts">
      {state === "working" && (
        <div className="flex items-center gap-2 text-slate-500">
          <Spinner /> Unsubscribing…
        </div>
      )}
      {state === "done" && (
        <>
          <Alert kind="success">
            Done — you won't get any more emails for that alert.
          </Alert>
          <p className="mt-4 text-sm text-slate-500">
            Changed your mind? You can set alerts back up any time from{" "}
            <Link to="/gear/alerts" className="font-semibold text-brand-600">
              your alerts page
            </Link>
            .
          </p>
        </>
      )}
      {state === "failed" && (
        <>
          <Alert>{error}</Alert>
          <p className="mt-4 text-sm text-slate-500">
            You can always manage alerts directly from{" "}
            <Link to="/gear/alerts" className="font-semibold text-brand-600">
              your alerts page
            </Link>
            .
          </p>
        </>
      )}
    </AuthLayout>
  );
}
